<template>
  <div class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        售前名称<span v-if="required && form.contractType!=='服务订单'" class="required">*</span>：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item :prop="form.contractType!=='服务订单' ? 'preSalesCode':''">
          <el-select
            ref="preSale"
            v-model="form.preSalesCode"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width:100%;"
            @change="change"
          >
            <el-option
              v-for="item in list"
              :key="item.userID"
              :label="item.userName"
              :value="item.userID"
            />
          </el-select>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getUserByName } from '@/API';
let timer;
export default {
  data () {
    return {
      list: [],
      loading: false
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.loading = true;
          getUserByName(query).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
            }
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      }
    },
    change (val) {
      this.$nextTick(() => {
        this.form.preSalesName = this.$refs.preSale.selectedLabel;
      });
    },
    initData () {
      if (this.form.preSalesCode) {
        this.list = [{
          userID: this.form.preSalesCode,
          userName: this.form.preSalesName
        }];
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="less"></style>
